<template>
    <div>
      <div v-for="(station, ind) in poi_data"
      :key="ind + 'stations'">
      <l-marker
        v-if="selected_filter_legend.includes(station[selected_filter.value])"
        :lat-lng="[station.lat, station.lon]"
        ref="marker"
        :name="station.ids.toString()"
        @click="$emit('marker-click', station)"
      >
        <l-icon :icon-anchor="[15, 15]">
          <div>
            <div v-if="live_zoom > 12" class="px-1" :style="getLabelStyle(station)">{{ station.ids }}</div>
  
            <template v-if="selected_radio_group === 'geolocation'">
              <img
                :src="'/img/geolocation/' + string_to_slug(station.geolocation) + '.png'"
                style="width:20px;position:absolute;top:4px;left:3px;"
              />
            </template>
            <template v-else>
              <i
                class="fa-solid fa-location-pin"
                :style="getPinStyle(station)"
              ></i>
            </template>
          </div>
        </l-icon>
  
        <l-tooltip>{{ station.akname }}</l-tooltip>
  
        <l-popup>
          <b-button class="mb-2" @click="$emit('open-tautotita', station)" size="sm">
            Ταυτότητα <i class="fa-solid fa-up-right-from-square"></i>
          </b-button>
  
          <br />
          <strong style="font-size: 20px;">Επισκόπηση Ακινήτου</strong>
          <table class="table table-bordered table-sm table-responsive" style="max-height: 350px;min-width: 345px;">
            <tbody>
              <tr v-for="(col, index) in table_columns" :key="index + 'table_col'">
                <td>{{ col.text }}</td>
                <td v-if="station[col.value] !== '' && station[col.value] !== false && station[col.value] !== true">{{ station[col.value] }}</td>
                <td v-if="typeof station[col.value] === 'boolean'">
                  <b-form-checkbox v-model="station[col.value]" name="checkbox-1" disabled></b-form-checkbox>
                </td>
                <td v-if="station[col.value] === ''">-</td>
              </tr>
  
              <tr>
                <td>Πληροφοριακό έντυπο</td>
                <td class="d-flex">
                  <i
                    class="fa-solid fa-file-pdf"
                    @click="$emit('open-pdf', station, 'pliroforiaka_entipa')"
                    style="cursor:pointer;font-size: 25px;color:red"
                  ></i>
                  <div v-if="tst"><b-spinner label="Spinning" small></b-spinner></div>
                </td>
              </tr>
              <tr>
                <td>Πίνακας μισθώσεων</td>
                <td class="d-flex">
                  <i
                    class="fa-solid fa-file-pdf"
                    @click="$emit('open-pdf', station, 'misthotiria')"
                    style="cursor:pointer;font-size: 25px;color:red"
                  ></i>
                  <div v-if="tst"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </l-popup>
      </l-marker>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "StationMarker",
    props: {
      poi_data: Array,
      selected_radio_group: String,
      options_radio_group: Array,
      orderSelected: Array,
      live_zoom: Number,
      table_columns: Array,
      tst: Boolean,
      string_to_slug: Function,
      selected_filter: Object,
      selected_filter_legend: Array,
    },
    watch: {
      selected_filter_legend: {
        handler() {
          console.log(this.selected_filter_legend);
        }
      }
    },

    methods: {
      getLabelStyle() {
        return {
          position: "absolute",
          top: this.selected_radio_group === "geolocation" ? "-10px" : "-15px",
          left: this.selected_radio_group === "geolocation" ? "-10px" : "-15px",
          zIndex: "1002",
          borderRadius: "20px",
          backgroundColor: "#fff",
          color: this.selected_radio_group === "geolocation" ? "#000" : "#161616",
          fontSize: this.selected_radio_group === "geolocation" ? "12px" : "13px",
          WebkitTextStrokeWidth: "1px",
          WebkitTextStrokeColor: "#000"
        };
      },
      getPinStyle(station) {
        const color =
          this.options_radio_group[this.orderSelected.indexOf(this.selected_radio_group)][
            station[this.selected_radio_group]
          ].color;
  
        return {
          color,
          fontSize: "20px"
        };
      }
    }
  };
  </script>
  